<section class="nearby-section" #nearbySection>
  <div class="container">
    <div class="section-header">
      <h2 class="section-title">Events Near You</h2>
      <p class="section-subtitle">Dance socials, festivals, and congresses happening in your area</p>
    </div>

    @if (loading) {
      <div class="loading-state">
        <div class="loading-spinner"></div>
        <p>Loading nearby events...</p>
      </div>
    }

    @if (error) {
      <div class="error-state">
        <p>{{ error }}</p>
        <button type="button" (click)="loadEvents(location)" class="retry-btn">Try Again</button>
      </div>
    }

    @if (!loading && !error) {
      @if (events.length === 0) {
        <div class="empty-state">
          <p>No events found near your location. Try increasing your search radius.</p>
        </div>
      } @else {
        <div class="events-grid">
          @for (event of events; track event.id) {
            <a [routerLink]="['/events', event.id]" class="event-card">
              <div class="event-image">
                <img [src]="event.imageUrl || placeholderImage" [alt]="event.name" [title]="event.name">
                <div class="event-type">{{ event.type }}</div>
              </div>
              <div class="event-content">
                <h3 class="event-title">{{ event.name }}</h3>
                <div class="event-details">
                  <div class="event-location">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                      <circle cx="12" cy="10" r="3"></circle>
                    </svg>
                    <span>{{ event.locationName || event.studio.name || event.city }}</span>
                  </div>
                  <div class="event-date">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
                      <line x1="16" y1="2" x2="16" y2="6"></line>
                      <line x1="8" y1="2" x2="8" y2="6"></line>
                      <line x1="3" y1="10" x2="21" y2="10"></line>
                    </svg>
                    <span>{{ formatDate(event.startTime) }}</span>
                  </div>
                </div>
                <div class="event-footer">
                  <span class="event-price">{{ formatPriceRange(event.priceTiers) }}</span>
                  <span class="view-btn">View Details</span>
                </div>
              </div>
            </a>
          }
        </div>

        <div class="view-more-wrap">
          <a
            routerLink="/events"
            [queryParams]="viewMoreParams"
            class="view-more-btn"
          >View More Events</a>
        </div>
      }
    }
  </div>
</section>
